import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { ClaimScreen } from 'screens/claim';

export default withPermissions(ClaimScreen, [GroupSecurity.ClaimRead]);
